module.exports = __webpack_public_path__ + "img/goodCount.38533c3b.png";